import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "ionic-angular";
import { PrnCountComponent } from "./prn-count";

@NgModule({
  declarations: [PrnCountComponent],
  imports: [CommonModule, IonicModule],
  exports: [PrnCountComponent],
})
export class PrnCountModule {}



// WEBPACK FOOTER //
// ./src/components/prn-count/prn-count.module.ts